<script lang="ts">
  import ExploreHeart from '$icons/ExploreHeartIcon.svelte';
  import Seed from '$icons/SeedIcon.svelte';
  import type { FPost } from 'garden-common';
  import ExploreComment from '$icons/ExploreCommentIcon.svelte';
  import ExploreFolder from '$icons/ExploreFolderIcon.svelte';
  import { me } from '$src/stores/user.store';
  import { createEventDispatcher, onMount } from 'svelte';
  import { api } from '$src/utils/api';

  export let post: Partial<FPost<string>> = null;

  let commonComment = false;
  let userDonation = false;
  let donations;

  $: if ($me && post && $me.userComments) {
    if (post.comments) {
      commonComment = post.comments.some(c => $me.userComments.includes(c));
    }
  }

  const dispatch = createEventDispatcher<{
    donate: never;
    appreciate: never;
    comment: never;
    save: never;
  }>();

  $: if ($me && post && !donations) {
    api.get(`/v2/donation/user/${$me._id}/post/${post._id}`).then(res => {
      donations = res.data.donations;
      if (donations.length > 0) {
        userDonation = true;
      }
    });
  }
</script>

<div class="flex gap-x-4 text-blueish-grey-700">
  <button on:click={() => dispatch('donate')}>
    {#key userDonation}
      <div class="hover:hover:scale-[1.5] scale-[1.3] transition ease-in-out">
        <Seed size={16} fill={userDonation ? '#0F9D58' : '#ADB9C5'} />
      </div>
    {/key}

    <div class="empty:bg-gray-100 h-6 empty:w-10 rounded">
      {post?.totalDonationsSeed ?? '0'}
    </div>
  </button>

  <button on:click={() => dispatch('appreciate')}>
    <div class="hover:hover:scale-[1.5] transition ease-in-out">
      <ExploreHeart size={16} class={post?.likes?.includes($me?._id) ? ' fill-[#FF0000]' : null} />
    </div>
    <div class="empty:bg-gray-100 h-6 empty:w-10 rbumpyounded">
      {post?.likes?.length ?? '0'}
    </div>
  </button>

  <button on:click={() => dispatch('comment')}>
    <div class="hover:scale-[1.5] transition ease-in-out">
      {#key commonComment}
        <ExploreComment size={16} class={commonComment ? 'fill-[#1DA1F2]' : null} />
      {/key}
    </div>
    <div class="empty:bg-gray-100 h-6 empty:w-10 rounded">
      {post?.comments?.length ?? '0'}
    </div>
  </button>

  <button on:click={() => dispatch('save')}>
    <div class="hover:scale-[1.5] transition ease-in-out">
      <ExploreFolder
        size={16}
        class={post?.savers?.includes($me?._id) ? 'fill-brand-green' : null}
      />
    </div>
    <!-- Not sure what this number should be iss 🚀 -->
    <div class="empty:bg-gray-100 h-6 empty:w-10 rounded">
      {post?.savers?.length ?? '0'}
    </div>
  </button>
</div>

<style lang="postcss">
  div > button {
    @apply flex gap-x-2 items-center;
  }
</style>
